import { mapValues } from 'lodash';

import {
  BoundingPolyRect,
  UDRsPolyAsset,
  UDRsPolyAssetStatus,
} from '@common-modules/mediaDetails/models';
import { Adapter } from '../interfaces';
import { ElementOf } from 'ts-essentials';

// we can probably get rid of this adapter now!

/**
 * Deprecated on 2019.3.15.
 * Required by switch to new V2F OT engine.
 */
export interface UDRsAssetV1 {
  readonly boundingPolys: {
    readonly [groupId: string]: {
      readonly label: string;
      readonly userLabel: string;
      readonly parentId: string;
      readonly series: ReadonlyArray<{
        readonly id: string;
        readonly startTimeMs: number;
        readonly stopTimeMs: number;
        readonly object: {
          readonly boundingPoly: BoundingPolyRect;
        };
      }>;
    };
  };
}

const mapper = (
  s: ElementOf<UDRsAssetV1['boundingPolys'][string]['series']>
) => ({
  ...s,
  object: {
    id: s.id,
    overlayObjectType: 'udr' as const,
    boundingPoly: s.object.boundingPoly,
  },
});

export const udrsAssetV1Adapter = (): Adapter<UDRsAssetV1, UDRsPolyAsset> => {
  const isMatch = (i: any): i is UDRsAssetV1 => !('version' in i);
  const adapt = (i: UDRsAssetV1): UDRsPolyAsset => ({
    boundingPolys: mapValues(i.boundingPolys, (p) => {
      const series = p.series.map(mapper);
      const firstSeries = series[0];
      if (!firstSeries) {
        return null;
      }
      return {
        label: p.label,
        userLabel: p.userLabel,
        groupId: p.parentId,
        status:
          p.series.length > 1
            ? UDRsPolyAssetStatus.GROUP
            : UDRsPolyAssetStatus.SINGLE,
        basePoly: firstSeries,
        series,
      };
    }),
  });

  return { isMatch, adapt };
};
